// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ImportModeConflict,
  ImportModeSystemConfig,
} from "./types";

export default {
  graphJson: __t.string(),
  get conflictMode() {
    return ImportModeConflict;
  },
  get configMode() {
    return ImportModeSystemConfig;
  },
};
